import {
  ADD_RATERS_INVITES,
  EDIT_RATERS_INVITES,
  LIST_RATERS_INVITES,
  VIEW_RATERS_INVITES,
  DELETE_RATERS_INVITES,
  ADD_RATERS_INVITES_TEXT,
  EDIT_RATERS_INVITES_TEXT,
  LIST_RATERS_INVITES_TEXT,
  VIEW_RATERS_INVITES_TEXT,
  DELETE_RATERS_INVITES_TEXT,
  RATERS_INVITES_SUCCESS,
  RATERS_INVITES_ERROR,
} from "./actionTypes"

const initialState = {
  successMsg: null,
  error: null,
  editLoading:false
}

const RatersInvites = (state = initialState, action) => {
  switch (action.type) {

    // add Invites
    case ADD_RATERS_INVITES:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
        
      }
      break
    case RATERS_INVITES_SUCCESS:
      state = {
        ...state,
        loading: false,
        successMsg: action.payload,
        editLoading:false
      }
      break
    case RATERS_INVITES_ERROR:
      state = { ...state, error: action.payload, loading: false, editLoading:false}
      break

    // edit Invites
    case EDIT_RATERS_INVITES:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        
        error: null,
      }
      break

    // list Invites
    case LIST_RATERS_INVITES:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // view Invites
    case VIEW_RATERS_INVITES:
      state = {
        ...state,
        successMsg: null,
        error: null,
      }
      break

    // delete Invites
    case DELETE_RATERS_INVITES:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // text
    // add Invites
    case ADD_RATERS_INVITES_TEXT:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break
    case RATERS_INVITES_SUCCESS:
      state = {
        ...state,
        loading: false,
        successMsg: action.payload,
        editLoading:false
      }
      break
    case RATERS_INVITES_ERROR:
      state = { ...state, error: action.payload, loading: false, editLoading:false}
      break

    // edit Invites
    case EDIT_RATERS_INVITES_TEXT:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break

    // list Invites
    case LIST_RATERS_INVITES_TEXT:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // view Invites
    case VIEW_RATERS_INVITES_TEXT:
      state = {
        ...state,
        successMsg: null,
        error: null,
      }
      break

    // delete Invites
    case DELETE_RATERS_INVITES_TEXT:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default RatersInvites
